import Base from '../base.js'
export default class Institution extends Base {
  constructor () {
    super('/institutions')
  }
}
